import React from 'react'
import {Icon} from '@chakra-ui/react'

const CopyLinkIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M5.99992 11.3327H4.66659C3.78253 11.3327 2.93468 10.9815 2.30956 10.3564C1.68444 9.73125 1.33325 8.8834 1.33325 7.99935C1.33325 7.11529 1.68444 6.26745 2.30956 5.64233C2.93468 5.01721 3.78253 4.66602 4.66659 4.66602H5.99992"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 4.66602H11.3333C12.2174 4.66602 13.0652 5.01721 13.6904 5.64233C14.3155 6.26745 14.6667 7.11529 14.6667 7.99935C14.6667 8.8834 14.3155 9.73125 13.6904 10.3564C13.0652 10.9815 12.2174 11.3327 11.3333 11.3327H10"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.33325 8H10.6666"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default CopyLinkIcon
